(function() {

window.productsAnchorButtons = Array.from(document.querySelectorAll('.landing-page__button'))

const section = window.productSection = document.querySelector(
  window.innerWidth <= 768 
    ? '.featured-product__product-content--js' 
    : '.featured-product-lp .featured-product__product-content'
);


function scrollToSection(section) {
  if (section) {
    const sectionTop = section.getBoundingClientRect().top;
    const offset = window.innerWidth <= 768? 0 : 100;

    window.scrollBy({
      top: sectionTop - offset,
      behavior: 'smooth',
    });

  }
}

function createScroll() {
  if(!window.productsAnchorButtons) {
    return
  }

  window.productsAnchorButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if(window.productsAnchorButtons) {
        scrollToSection(section);
        return
      }

      scrollToSection(section);
    });
  });
}

createScroll()
})()